<template>
  <div class="w1200 orderlist">
      <div class="mtitle">我的发票</div>
      <el-table class="mt_20"
        :data="tableData" :header-cell-style="{ background: '#F4F8FC' }"
        border
        style="width: 100%">
        <el-table-column
        prop="yjsjlx_name" align="center"
        label="支付模板">
        </el-table-column>
        <el-table-column
        prop="paytime" align="center"
        label="支付时间">
        </el-table-column>
        <el-table-column
        prop="payamount" align="center"
        label="支付金额">
        </el-table-column>
        <el-table-column
        align="center"
        label="开票状态">
        <template slot-scope="scope">
           <span v-if="scope.row.fpstatus==1">未开票</span>
           <span v-else>
                {{ scope.row.fpscstatus==2?'已开票':'申请中' }}
           </span>
        </template>
        </el-table-column>
        
        <el-table-column
        align="center"
        label="操作">
        <template slot-scope="scope">
            <el-link type="primary" v-if="scope.row.fpstatus==1" @click="shenqing(scope.row.id)">申请开票</el-link>
            <el-link type="primary" v-if="scope.row.fpscstatus==2" @click="down(scope.row)">下载发票</el-link>
        </template>
        </el-table-column>
    </el-table>
    <div class="fy" v-if="total>0">
        <el-pagination :popper-append-to-body="false"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searchitem.pageNo"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="searchitem.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
   </div> 


   <el-dialog
        title="申请开票" 
        :visible.sync="dialogVisible"
        width="400px">
        <div class="kaipiao">
             <el-form ref="form" :model="form" label-width="100px" label-position="right">

 
  <el-form-item label="开票类型">
    <el-radio-group v-model="form.fptype">
      <el-radio label="1">个人</el-radio>
      <el-radio label="2">单位</el-radio>
    </el-radio-group>
  </el-form-item>
   <el-form-item label="单位名称">
    <el-input v-model="form.fptaitou" placeholder="请输入单位名称"></el-input>
  </el-form-item>
   <el-form-item label="纳税识别号">
    <el-input v-model="form.fpshuihao" placeholder="请输入纳税识别号"></el-input>
  </el-form-item>
</el-form>
            <el-button type="primary" class="tjbtn" @click="sendsq">提交</el-button>
        </div>
      </el-dialog>
    
  </div>
</template>

<script>
import {getFapiaoList,orderkaipiao } from "@/api/index.js"
export default {
  data() {
    return {
        dialogVisible:false,
        form:{
            id:'',
            fptype:'',
            comname:'',
            code:''
        },
        searchitem:{
            pageNo:1,
            pageSize:10
        },
     tableData: [],
      total:0,
    }
  },
   mounted(){
this.getlist()
  },
  methods:{
    shenqing(id){
      this.form.id=id;
this.dialogVisible=true
    },
    sendsq(){
      orderkaipiao(this.form).then(res=>{
        if(res.code==1){
           this.$message({
                    message: '已提交申请',
                    type: 'success'
                  });
                  this.dialogVisible=false
              this.searchitem.pageNo=1
             this.getlist()     
        }
      })
    },
    down(row){
  window.open(this.$imgurl(row.fp_url),'_blank')
    },
     getlist(){
      getFapiaoList(this.searchitem).then(res=>{
        if(res.code==1){
          this.tableData=res.data.rows;
          this.total=res.data.total
        }
     })
    },
    handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.searchitem.pageSize=val;
        this.getlist()
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
         this.searchitem.pageNo=val;
        this.getlist()
      }
  }
};
</script>

<style lang="less">
.kaipiao {
    padding:40px;
    .el-form-item__label {font-weight: bold!important;}
    .tjbtn {
        font-size: 20px;background:#2397CA;margin-top:10px;width:100%;
    }
}
</style>
